
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  viewBox: "0 0 15 14",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.782 1.602c1.756.441 3.128 1.721 3.6 3.36M8.256 3.44c1.053.265 1.876 1.033 2.16 2.017",
  stroke: "#000",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.274 6.643c.58 1.108 1.543 2.003 2.733 2.54a.589.589 0 0 0 .548-.039l1.753-1.09a.594.594 0 0 1 .531-.046l3.279 1.311c.229.091.366.312.336.542-.215 1.566-1.642 2.74-3.334 2.74C4.862 12.6.6 8.621.6 3.714.6 2.136 1.857.804 3.535.604c.247-.028.483.1.58.313L5.523 3.98a.493.493 0 0 1-.046.492L4.31 6.132a.489.489 0 0 0-.037.51Z",
  stroke: "#000",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"24\" viewBox=\"0 0 15 14\" fill=\"none\">\r\n<path d=\"M8.78223 1.60239C10.5381 2.04314 11.9097 3.32327 12.3819 4.96212\" stroke=\"black\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M8.25586 3.44083C9.30941 3.70528 10.1323 4.47336 10.4157 5.45667\" stroke=\"black\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.27352 6.64288C4.85441 7.7513 5.81707 8.6457 7.00731 9.18282C7.18448 9.26118 7.3928 9.24647 7.55533 9.14412L9.30786 8.0534C9.46533 7.9554 9.66518 7.93826 9.83915 8.00785L13.1178 9.31931C13.3466 9.41003 13.4836 9.63104 13.4537 9.86138C13.2393 11.4272 11.8116 12.6003 10.1203 12.6004C4.86244 12.6004 0.600098 8.62222 0.600098 3.71488C0.600187 2.13635 1.85713 0.803811 3.53477 0.603709C3.78156 0.575835 4.01835 0.703651 4.11555 0.9172L5.52191 3.97995C5.5958 4.14085 5.57847 4.32559 5.47576 4.47207L4.31119 6.13286C4.20337 6.28484 4.18906 6.47852 4.27352 6.64288Z\" stroke=\"black\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/phone-icon.32def055b9aa3a47f34192b340c8ac7b.svg"),
        {
          React: SvgPhoneIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      